module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "namespaces-show-page"
  }, [_c('panel', [_c('div', {
    slot: "heading-left"
  }, [_c('h5', [_c('a', {
    attrs: {
      "data-placement": "right",
      "data-toggle": "popover",
      "data-container": ".panel-heading",
      "data-content": "<p>Information about the namespace.</p>",
      "data-original-title": "What's this?",
      "tabindex": "0",
      "data-html": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  })]), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(_vm.namespace.name) + " ")]), _vm._v("\n        namespace\n      ")])]), _vm._v(" "), _c('div', {
    slot: "heading-right"
  }, [(_vm.canManageNamespace) ? _c('toggle-link', {
    staticClass: "toggle-link-edit-namespace",
    attrs: {
      "text": "Edit namespace",
      "state": _vm.state,
      "state-key": "editFormVisible",
      "false-icon": "fa-pencil",
      "true-icon": "fa-close"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    slot: "body"
  }, [(!_vm.state.editFormVisible) ? _c('namespace-info', {
    attrs: {
      "namespace": _vm.namespace
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state.editFormVisible) ? _c('edit-namespace-form', {
    attrs: {
      "namespace": _vm.namespace
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-v2.3/~/vue-loader/lib/template-compiler?{"id":"data-v-ea0e8ce0"}!/home/abuild/rpmbuild/BUILD/Portus-v2.3/~/vue-loader/lib/selector.js?type=template&index=0!./modules/namespaces/pages/show.vue
// module id = 366
// module chunks = 0